module.exports = __webpack_public_path__ + "img/servicetext-sm.c74be0b9.png";